import { Button } from "../../../bootstrap.js";
import "./linkButton.css";

export function LinkButtonLight({href}) {
  return <Button href={href} className="linkButton light"
  aria-label="Learn more about the Blind Scientist Toolkit.">
    
  </Button>;
}
